import React, { useState } from "react";
import { LineItemOrderDefinition, EstimateMatchCriteria, LineItemOrderObject } from "../../../types";
import CopyOrderFromModal from "./CopyOrderFromModal";

interface CopyOrderFromButtonProps {
	lineItemOrderObjects: LineItemOrderObject[];
	currentMatchCriteria: EstimateMatchCriteria;
	lineItemOrderDefinitions: LineItemOrderDefinition[];
	onCopy: (sourceObjects: LineItemOrderObject[]) => void;
}

const CopyOrderFromButton: React.FC<CopyOrderFromButtonProps> = ({
	lineItemOrderObjects,
	currentMatchCriteria,
	lineItemOrderDefinitions,
	onCopy,
}) => {
	const [showModal, setShowModal] = useState(false);
	const isDisabled = lineItemOrderObjects.length > 0;

	return (
		<div className="relative group inline-block">
			<button
				onClick={() => setShowModal(true)}
				disabled={isDisabled}
				className="px-4 py-2 bg-gray-100 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-200 transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
			>
				<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
				</svg>
				Copy Order From
			</button>
			{isDisabled && (
				<div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block w-64 px-3 py-2 bg-gray-800 text-white text-xs rounded-md shadow-lg text-center pointer-events-none z-10">
					Delete line items in this order before copying from another
					<div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
				</div>
			)}
			<CopyOrderFromModal
				isOpen={showModal}
				onClose={() => setShowModal(false)}
				currentMatchCriteria={currentMatchCriteria}
				lineItemOrderDefinitions={lineItemOrderDefinitions}
				onCopy={onCopy}
			/>
		</div>
	);
};

export default CopyOrderFromButton;
